<template>
  <div class="date-group">
    <el-row :gutter="40">
      <el-col :span="12">
        <div class="date-group-item transition-label">
          <el-button
            class="egl-btn-yellow date-group-btn"
            @click="getCurDay(-1, 'startDate')"
          >
            <i class="el-icon-arrow-left"></i>
          </el-button>
          <el-date-picker
            class="date-group-input"
            type="date"
            v-model="filter.startDate"
            :clearable="false"
            @change="getCurDay('', 'startDate')"
            value-format="timestamp"
            :format="`yyyy-MM-dd (${filter.startDateText})`"
            :picker-options="startTimePickerOptions"
            :disabled="disabled"
          >
          </el-date-picker>
          <el-button
            class="egl-btn-yellow date-group-btn"
            @click="getCurDay(1, 'startDate')"
          >
            <i class="el-icon-arrow-right"></i>
          </el-button>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="date-group-item">
          <el-button
            class="egl-btn-yellow date-group-btn"
            @click="getCurDay(-1, 'endDate')"
          >
            <i class="el-icon-arrow-left"></i>
          </el-button>
          <el-date-picker
            class="date-group-input"
            type="date"
            v-model="filter.endDate"
            :clearable="false"
            @change="getCurDay('', 'endDate')"
            value-format="timestamp"
            :format="`yyyy-MM-dd (${filter.endDateText})`"
            :picker-options="endTimePickerOptions"
            :disabled="disabled"
          >
          </el-date-picker>
          <el-button
            class="egl-btn-yellow date-group-btn"
            @click="getCurDay(1, 'endDate')"
          >
            <i class="el-icon-arrow-right"></i>
          </el-button>
        </div>
      </el-col>
    </el-row>
    <!-- <span class="date-group-connect">~</span> -->
  </div>
</template>

<script>
import { weekLocaleArray } from "@/utils/common";

export default {
  name: "DatePickerGroup",
  data() {
    return {
      filter: {
        startDateText: "",
        endDateText: "",
        startDate: "",
        endDate: ""
      },
      endTimePickerOptions: {
        disabledDate: this.endTimeDisableDate
      },
      startTimePickerOptions: {
        disabledDate: this.startTimeDisableDate
      },
    };
  },
  methods: {
    endTimeDisableDate(time) {
      let maxDate = "";

      if (this.max) {
        maxDate = this.max;
      } else {
        maxDate = Date.now();
      }
      if (this.isNotLimit) {
        return time.getTime() < this.$moment(this.filter.startDate).valueOf();
      }
      return (
        time.getTime() > maxDate ||
        time.getTime() < this.$moment(this.filter.startDate).valueOf()
      );
    },
    startTimeDisableDate(time) {
      if (!this.isNotLimit) {
        return time.getTime() > this.$moment(this.filter.endDate).valueOf();
      }
    },
    getCurDay(num = "", keyName) {
      const today = this.$moment().valueOf();
      let maxDate = 0;
      let newFilter = { ...this.filter };
      let day = "";

      if (num == "") {
        day = this.$moment(newFilter[keyName]).valueOf();
      } else {
        day = this.$moment(newFilter[keyName])
          .subtract(-num, "days")
          .valueOf();
      }

      if (this.max) {
        maxDate = this.max;
      } else {
        maxDate = today;
      }

      newFilter[keyName] = day;

      newFilter.endDate = newFilter.endDate < newFilter.startDate ? newFilter.startDate : newFilter.endDate;
      if (!this.isNotLimit) {
        newFilter.endDate = newFilter.endDate > maxDate ? maxDate : newFilter.endDate;
      }
      newFilter.startDate = newFilter.startDate > newFilter.endDate ? newFilter.endDate : newFilter.startDate;

      this.$emit("setFatherDate", {
        startDate: newFilter.startDate,
        endDate: newFilter.endDate
      });
    }
  },
  mounted() {
    // let curDay = this.$moment().valueOf();
    let curDay2 = this.$moment().startOf("day").valueOf();
    let startDate = "";
    let endDate = "";
    let startDateText = "";
    let endDateText = "";

    // if (this.end == 0) {
    //   endDate = curDay;
    // }
    // if (this.start == 0) {
    //   startDate = endDate;
    // }
    startDate = this.start === 0 ? curDay2 : this.start;
    endDate = this.end === 0 ? curDay2 : this.end;
    startDateText = weekLocaleArray[this.$moment(startDate).day()];
    endDateText = weekLocaleArray[this.$moment(endDate).day()];

    this.filter = {
      startDateText: startDateText,
      endDateText: endDateText,
      startDate: startDate,
      endDate: endDate
    };
  },
  props: {
    start: {
      type: Number,
      default: () => 0
    },
    end: {
      type: Number,
      default: () => 0
    },
    max: {
      type: Number,
      // default: Infinity,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isExp: {
      type: Boolean,
      default: false,
    },
    isNotLimit: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    end() {
      let startDateText = weekLocaleArray[this.$moment(this.start).day()];
      let endDateText = weekLocaleArray[this.$moment(this.end).day()];

      this.filter = {
        startDateText: startDateText,
        endDateText: endDateText,
        startDate: this.$moment(this.start).valueOf(),
        endDate: this.$moment(this.end).valueOf()
      };
    },
    start() {
      let startDateText = weekLocaleArray[this.$moment(this.start).day()];
      let endDateText = weekLocaleArray[this.$moment(this.end).day()];

      this.filter = {
        startDateText: startDateText,
        endDateText: endDateText,
        startDate: this.$moment(this.start).valueOf(),
        endDate: this.$moment(this.end).valueOf()
      };
    }
  }
};
</script>

<style lang="less" scoped>
.date-group {
  position: relative;
  display: inline-block;
  width: 100%;
  max-width: 620px;
  vertical-align: middle;

  .date-group-item {
    display: inline-flex;
    width: 100%;
    max-width: 294px;

    .date-group-btn {
      width: 40px;
      height: 40px;
      padding: 0;
    }

    .date-group-input {
      flex: 1;
      padding: 0 10px;

      .el-input__prefix {
        left: auto;
        right: 20px;
      }

      .el-input__inner {
        padding-left: 15px;
        padding-right: 40px;
      }
    }
  }

  .date-group-connect {
    width: 20px;
    height: 100%;
    line-height: 40px;
    margin-left: -10px;
    position: absolute;
    top: 0;
    left: 50%;
    text-align: center;
    font-size: 1.6rem;
  }

  .transition-label {
    position: relative;

    &::after {
      content: "~";
      display: block;
      position: absolute;
      height: 40px;
      line-height: 40px;
      font-size: 1.4rem;
      top: 0;
      right: -25px;
    }
  }
}
</style>
